// project modules
import { getBaseUrl, sendRequest } from '../helpers/apiHelper';

export const getAccountBalance = async (abortSignal?: AbortSignal) => {
  return await sendRequest(`${getBaseUrl()}/SmsPanel/accountBalance`, 'get', null, null, abortSignal);
};

export const getAccountSentSmsStatistics = async (abortSignal?: AbortSignal) => {
  return await sendRequest(`${getBaseUrl()}/SmsPanel/sentSmsStatistics`, 'get', null, null, abortSignal);
};

export const getAdminBanks = async (abortSignal?: AbortSignal) => {
  return await sendRequest(`${getBaseUrl()}/SmsPanel/adminBanks`, 'get', null, null, abortSignal);
};

export const insertPayingInSlip = async (data:any, abortSignal?: AbortSignal) => {
  return await sendRequest(`${getBaseUrl()}/SmsPanel/payingInSlip`, 'post', data, null, abortSignal);
};

